//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return{
      list: [
        {
          value: 'A记录',
          name: 'A记录',
        },
        {
          value: 'CNAME记录',
          name: 'CNAME记录',
        },
        {
          value: 'MX记录',
          name: 'MX记录',
        },
        {
          value: 'TXT记录',
          name: 'TXT记录',
        },
        {
          value: 'IPv6记录',
          name: 'IPv6记录',
        }
      ],
      analyList:{
        set_type:['A记录'],
        title:'',
        content:'',
        ttl:['2分钟'],
        mx:''
      },
      list1: [
        {
          value: '2分钟',
          name: '2分钟',
        },
        {
          value: '10分钟',
          name: '10分钟',
        },
        {
          value: '30分钟',
          name: '30分钟',
        },
        {
          value: '1小时',
          name: '1小时',
        },
        {
          value: '2小时',
          name: '2小时',
        }
      ],
    }
  },
  methods:{
    async submit() {
      let set_type;
      let ttl;
      switch (this.analyList.set_type[0]) {
        case 'A记录':
          set_type = 'a'
          break
        case 'CNAME记录':
          set_type = 'cname'
          break
        case 'MX记录':
          set_type = 'mx'
          break
        case 'TXT记录':
          set_type = 'txt'
          break
        case 'IPv6记录':
          set_type = 'aaaa'
          break
      }
      switch (this.analyList.ttl[0]) {
        case '2分钟':
          ttl = '120'
          break
        case '10分钟':
          ttl = '600'
          break
        case '30分钟':
          ttl = '1800'
          break
        case '1小时':
          ttl = '3600'
          break
        case '2小时':
          ttl = '7200'
          break
      }
      let data = 'cmd=jiexi_add&domainname='+this.$route.params.name+
        '&set_type='+set_type+
        '&mx='+this.analyList.mx+
        '&title='+this.analyList.title+
        '&content='+this.analyList.content+
        '&ttl='+ttl;
      let _this = this
      this.$http.post('https://api.abeiyun.com/www/domain.php',data).then(({data})=>{
        if(data.response == 200 ) {
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
            onHide () {
              _this.$router.push('/user/domainanaly/'+ _this.$route.params.name)
            }
          })
        }else{
          this.$vux.alert.show({
            title: '提示信息',
            content: data.msg,
          })
        }
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/console/analyadd.vue